/** Remaining access-token lifetime in seconds from the server, or null if unavailable. */
export async function fetchSessionExpiresIn(): Promise<number | null> {
  try {
    const response = await fetch('/api/sessions/token-status', {
      method: 'GET',
      credentials: 'include',
    })
    if (!response.ok) return null
    const data = (await response.json()) as {
      data?: { tokenExpiration?: { expiresIn?: number } }
    }
    const expiresIn = data?.data?.tokenExpiration?.expiresIn
    return typeof expiresIn === 'number' ? expiresIn : null
  } catch {
    return null
  }
}

/** Single countdown value for expired-session flows when server time is unknown or zero. */
export const EXPIRED_SESSION_GRACE_SECONDS = 15

export function resolveSessionCountdownSeconds(expiresIn: number | null): number {
  if (expiresIn !== null && expiresIn > 0) return expiresIn
  return EXPIRED_SESSION_GRACE_SECONDS
}
